module.exports = __webpack_public_path__ + "assets/img/title-efdc18d9.png";